// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jLse","buttons":"Footer_buttons__yfMYe"};